import React, { lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AppProviders from "./AppProviders";
import { PublicRoutes, DashboardRoutes, NotFoundPage } from "./routes/appRoutes";
import Middleware from "./Middleware";
import "nprogress/nprogress.css";
import NavigationProgress from "./components/shared/NavigationProgress";
import GlobalNavigationBridge from "./components/shared/GlobalNavigationBridge";
import RouteErrorBoundary from "./components/shared/RouteErrorBoundary";

const DetailedOverviewUpload = lazy(
  () => import("./pages/Details/DetailedOverview/DetailedOverviewUpload"),
);
const VideoUploadPopover = lazy(
  () => import("./pages/Details/DetailedOverview/VideoUploadPopover"),
);

function App() {
  const { t } = useTranslation();

  return (
    <AppProviders>
      <div className="App w-full">
        <DetailedOverviewUpload />
        <BrowserRouter>
          <RouteErrorBoundary
            title="A page crashed"
            message="A rendering error was contained so the app did not fully crash. You can retry this section or reload the app."
          >
            <NavigationProgress />
            <GlobalNavigationBridge />
            <Middleware>
              <Routes>
                {PublicRoutes()}
                {DashboardRoutes(t)}
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Middleware>
          </RouteErrorBoundary>
        </BrowserRouter>
        <VideoUploadPopover />
      </div>
    </AppProviders>
  );
}

export default App;
